/***************************************************************
5/22/2017
Alexander Self
Inputs
- Different form inputs
***************************************************************/
import React from 'react';
import moment from 'moment';
const $ = window.$;

/* Must call document.ready to invoke Datepicker */
export function DatePicker({ 
  id, 
  label, 
  min, 
  max, 
  disabled 
}) {
  $(document).ready(() => {
    $(`#${id}`).pickadate({
      selectMonths: true, // Creates a dropdown to control month
      selectYears: 2, // Creates a dropdown of 15 years to control year
      format: 'yyyy-mm-dd',
      min,
      max
    });
  });
  return (
    <div>
      <label htmlFor={id}>{label}</label>
      <input id={id} type="text" className="datepicker" disabled={disabled} />
    </div>
  );
}

export function DatePicker2({ 
  id, 
  label, 
  min, 
  max, 
  disabled, 
  defaultValue 
}) {
  return (
    <div>
      <label htmlFor={id}>{label}</label>
      <input 
        type="date" 
        id={id} 
        disabled={disabled} 
        min={min} 
        max={max}
        defaultValue={defaultValue} 
      />
    </div>
  );
}

export function ClockPicker({ id, label }) {
  $(document).ready(() => {
    $(`#${id}`).pickatime({
     autoclose: false,
     twelvehour: true
   });
 });
  return (
    <div>
      <label htmlFor={id}>{label}</label>
      <input id={id} className="timepicker" type="time" />
    </div>
  )
}

export function TimePicker2({ 
  id, 
  label, 
  defaultValue 
}) {
  return (
    <div>
      <label htmlFor={id}>{label}</label>
      <input id={id} type="time" defaultValue={defaultValue} />
    </div>
  )
}

export function TextInput({ 
  id, 
  label, 
  defaultValue, 
  placeholder, 
  onChange 
}) {
  return (
    <div>
      <label>{label}</label>
      <input id={id} type="text" defaultValue={defaultValue} placeholder={placeholder} onChange={onChange} />
    </div>
  );
}

export function PasswordInput({ id, label }) {
  return (
    <div>
      <label>{label}</label>
      <input id={id} type="password" />
    </div>
  );
}

export function NumberInput({ 
  id, 
  label, 
  min, 
  max, 
  step, 
  value, 
  onChange, 
  defaultValue, 
  placeholder, 
  disabled, 
  _class, 
  _inputClass, 
  name 
}) {
  return (
    <div>
      <label className={_class}>{label}</label>
      <input className={_inputClass} id={id} type="number" min={min} max={max} step={step} value={value} onChange={onChange}
        defaultValue={defaultValue} placeholder={placeholder} disabled={disabled} name={name}
      />
    </div>
  );
}

export function Select({ 
  id, 
  opts, 
  label, 
  onChange, 
  defaultValue 
}) {
  $(document).ready(() => {
    $(`#${id}`).material_select();
  });
  return (
    <div>
      <label>{label}</label>
      <select 
        id={id} 
        className="browser-default" 
        defaultValue={defaultValue}
        onChange={onChange}>
        <option value=""></option>
        {
          opts.map((opt) => (
            <option
              id={opt.label} 
              key={opt.label} 
              value={opt.val}>
              {opt.label}
            </option>
          ))
        }
      </select>
    </div>
  )
}
/* Specifically for the fields
  Set selected as true for default value
*/
export function SelectField({ 
  id, 
  opts, 
  label, 
  onChange, 
  selected, 
  defaultValue 
}) {
  $(document).ready(() => {
    $(`#${id}`).material_select();
  });
  return (
    <div>
      <label>{label}</label>
      <select id={id} className="browser-default" onChange={onChange}>
        <option value=""></option>
        {
          opts.map((opt) => {
            if (selected && opt.field === defaultValue) {
              return (
                <option key={opt.field} value={opt.field} selected>{opt.field}</option>
              )
            }
            return (
              <option key={opt.field} value={opt.field}>{opt.field}</option>
            )
          })
        }
      </select>
    </div>
  )
}
/* Specifically for the fields */
export function SelectBlock({ 
  id, 
  opts, 
  label 
}) {
  $(document).ready(() => {
    $(`#${id}`).material_select();
  });
  return (
    <div>
      <label>{label}</label>
      <select id={id} className="browser-default">
        <option defaultValue=""></option>
        {
          opts.map((opt) => (
            <option key={opt.block} value={opt.block}>{opt.block}</option>
          ))
        }
      </select>
    </div>
  )
}
/* Specifically for multiple fields */
export function SelectMultipleField({ id, opts, label }) {
  $(document).ready(() => {
    $(`#${id}`).material_select();
  });
  return (
    <div>
      <label>{label}</label>
      <select id={id} multiple>
        <option defaultValue=""></option>
        {
          opts.map((opt) => (
            <option key={opt.field} value={opt.field}>{opt.field}</option>
          ))
        }
      </select>
    </div>
  )
}
/* Specifically for the cost centers */
export function SelectCostCenter({ 
  id, 
  opts, 
  label, 
  onChange 
}) {
  $(document).ready(() => {
    $(`#${id}`).material_select();
  });
  return (
    <div>
      <label>{label}</label>
      <select id={id} className="browser-default" onChange={onChange}>
        <option defaultValue=""></option>
        {
          opts.map((opt) => (
            <option key={opt.id} value={`${opt.costNo}-${opt.department}-${opt.location}`}>{opt.costNo} - {opt.department} ({opt.location})</option>
          ))
        }
      </select>
    </div>
  )
}
/* Specifically for the subaccounts */
export function SelectSubAccount({ 
  id, 
  opts, 
  label, 
  onChange 
}) {
  $(document).ready(() => {
    $(`#${id}`).material_select();
  });
  return (
    <div>
      <label>{label}</label>
      <select id={id} className="browser-default" onChange={onChange}>
        <option defaultValue=""></option>
        {
          opts.map((opt) => (
            <option key={opt.accountNo} id={opt.accountDesc} value={opt.accountNo}>({opt.costCenter}) {opt.subAccountNo} - {opt.accountDesc}</option>
          ))
        }
      </select>
    </div>
  )
}
/* Specifically for the equipment */
export function SelectEquipment({ 
  id, 
  opts, 
  label 
}) {
  $(document).ready(() => {
    $(`#${id}`).material_select();
  });
  return (
    <div>
      <label>{label}</label>
      <select id={id} className="browser-default">
        <option defaultValue=""></option>
        {
          opts.map((opt) => (
            <option key={opt.id} value={opt.equipmentNo}>{opt.equipmentNo} - {opt.description} ({opt.companyCode})</option>
          ))
        }
      </select>
    </div>
  )
}
/* Specifically for the payperiods */
export function SelectPayPeriod({ 
  id, 
  opts, 
  label, 
  onChange 
}) {
  $(document).ready(() => {
    $(`#${id}`).material_select();
  });
  return (
    <div>
      <label>{label}</label>
      <select id={id} className="browser-default" onChange={onChange}>
        <option defaultValue=""></option>
        {
          opts.map((opt) => (
            <option key={opt.id} value={`${moment(opt.startDate).format('YYYY-MM-DD')}/${moment(opt.endDate).format('YYYY-MM-DD')}`}>
              {`${moment(opt.startDate).format('YYYY-MM-DD')} -> ${moment(opt.endDate).format('YYYY-MM-DD')}`}
            </option>
          ))
        }
      </select>
    </div>
  )
}

export function FloatingButton({ 
  color, 
  icon, 
  onclick, 
  disabled, 
  id 
}) {
  if (disabled) {
    return (
      <button disabled className={`btn-floating waves-effect waves-light ${color}`}
        onClick={onclick}>
        <i className="material-icons">{icon}</i>
      </button>
    )
  }
  return (
    <button id={id} className={`btn-floating waves-effect waves-light ${color}`}
      onClick={onclick}>
      <i className="material-icons">{icon}</i>
    </button>
  )
}

export function Textarea({ id, label }) {
  $(document).ready(function() {
    $(`textarea#${id}`).characterCounter();
  });
  return (
    <div>
      <label htmlFor={id}>{label}</label>
      <textarea id={id} className="materialize-textarea" data-length="350"></textarea>
    </div>
  )
}

/* Materialze autocomplete: pass in onComplete callback to get value + id */
export function AutoComplete({ 
  id, 
  label, 
  data, 
  onComplete, 
  disabled 
}) {
  $(document).ready(() => {
    $(`#${id}`).autocomplete({
      data: data,
      limit: 10,
      minLength: 1,
      onAutocomplete: (val) => {
        onComplete(val, id);
      }
    });
  });
  return (
    <div>
      <label htmlFor={id}>{label}</label>
      <input type="text" id={id} className="autocomplete" disabled={disabled} />
    </div>
  )
}
/* Basic file button */
export function FileButton({ id, name, label }) {
  return (
    <div className="file-field input-field">
      <div className="btn btn-flat">
        <span>{label}</span>
        <input id={id} name={name} type="file"  />
      </div>
      <div className="file-path-wrapper">
        <input id="file-path" className="file-path validate" type="text" />
      </div>
    </div>
  )
}

export function RadioButton({ id, name, label, disabled, onClick }) {
  return (
    <div>
      <input id={id} name={name} type="radio" disabled={disabled} onClick={onClick} />
      <label htmlFor={id}>{label}</label>
    </div>
  )
}

export function CheckBox({ id, name, label, disabled }) {
  return (
    <div>
      <input id={id} name={name} type="checkbox" disabled={disabled} />
      <label htmlFor={id}>{label}</label>
    </div>
  )
}

export function HiddenInput({ id, value }) {
  return (
    <div>
      <input id={id} type="hidden" value={value} />
    </div>
  );
}



/* END */



// WEBPACK FOOTER //
// ./src/components/inputs.js